import { RENDER_TYPE_3D } from '../../../../model/factoryRenderers';
import store from '../../../../store/store';
import { is3DRenderingAvailable } from '../../Viewer/getVolumeManager';
import toolNames from './toolNames';
import { toolsConfig } from './toolsConfig';
import {
  filterAndOrderToolsByNamesList,
  getOrderedToolNamesByDevice,
  loadGroupedTools,
  loadRotationTools,
  loadZoomTools,
  TYPE_TOOLSET_2D
} from './toolsetUtils';

const show3DTool = (config, currentLayoutElement) => (
  config.WITH_RENDER_3D
  && is3DRenderingAvailable()
  && currentLayoutElement?.availableRenderers?.includes(RENDER_TYPE_3D)
);

const showTool = (toolName, config, currentLayoutElement) => {
  switch (toolName) {
    case toolNames.MODE_MPR:
    case toolNames.MODE_3D:
      return show3DTool(config, currentLayoutElement);
    case toolNames.ANONYMIZE:
      return (config.WITH_PATIENT_DISCLOSED);
    default:
      return true;
  }
};

const filterToolsetBy2DConditions = (toolset, config, currentLayoutElement) => {
  return toolset.filter((tool) => {
    return showTool(tool.name, config, currentLayoutElement);
  });
};

export const getToolset2D = (currentLayoutElement) => {
  const { config } = store.getState();

  const groupedTool = loadGroupedTools();
  groupedTool.groupedTools = filterToolsetBy2DConditions(groupedTool.groupedTools, config, currentLayoutElement);
  const rotationTool = loadRotationTools();
  rotationTool.groupedTools = filterToolsetBy2DConditions(rotationTool.groupedTools, config, currentLayoutElement);
  loadZoomTools();

  const toolset2DOrderedNames = getOrderedToolNamesByDevice(TYPE_TOOLSET_2D);

  const filteredToolset2D = filterAndOrderToolsByNamesList(toolsConfig, toolset2DOrderedNames);

  return filterToolsetBy2DConditions(filteredToolset2D, config, currentLayoutElement);
};
